import { css } from "@emotion/css";
import { Callout, List, ListItemContent, ListItemLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import type { RetentionPolicy } from "~/areas/library/components/Retention/RetentionPolicyTypes";
import { policies } from "~/areas/library/components/Retention/RetentionPolicyTypes";
import { BorderedContent } from "~/components/BorderedContent/BorderedContent";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import MarkdownDescription from "~/components/MarkdownDescription/index";
import ExternalLink from "~/components/Navigation/ExternalLink/ExternalLink";
import { RedirectAs404 } from "~/components/NotFound/NotFound";
import { PageContent } from "~/components/PageContent/PageContent";
import useLocalStorage from "~/hooks/useLocalStorage";
import ListTitle from "~/primitiveComponents/dataDisplay/ListTitle/index";
interface RetentionPoliciesPageProps {
    spaceId: string;
}
interface RetentionPolicyListItemProps {
    spaceId: string;
    retentionPolicy: RetentionPolicy;
}
const pageTitle = "Retention Policies";
export function RetentionPoliciesPage({ spaceId }: RetentionPoliciesPageProps) {
    const [calloutDismissed, setCalloutDismissed] = useLocalStorage<boolean>("Octopus.Callout.Retention.MoreRetentionPolicyDismissed", false);
    if (!isFeatureToggleEnabled("centralized-retention-lifecycle") && !isFeatureToggleEnabled("centralized-retention-v2")) {
        return <RedirectAs404 />;
    }
    return (<PageContent header={{ title: pageTitle }}>
            {!calloutDismissed && (<div className={styles.calloutContainer}>
                    <Callout type="new-feature" title="More retention settings coming soon" canClose onClose={() => setCalloutDismissed(true)}>
                        We're adding more options to give you a greater control over how retention is managed.
                        <br />
                        We'd love to <ExternalLink href={"centralized-retention-lifecycle-feedback"}>hear about your experience</ExternalLink>.
                    </Callout>
                </div>)}

            <BorderedContent>
                <List items={policies} renderRow={({ item: retentionPolicy }) => <RetentionPolicyListItem spaceId={spaceId} retentionPolicy={retentionPolicy}/>} rowKey={(policy) => policy.type}/>
            </BorderedContent>
        </PageContent>);
}
function RetentionPolicyListItem({ retentionPolicy, spaceId }: RetentionPolicyListItemProps) {
    if (retentionPolicy.featureFlag && !isFeatureToggleEnabled(retentionPolicy.featureFlag)) {
        return null;
    }
    return (<ListItemLink href={retentionPolicy.pathFunction({ spaceId })}>
            <ListItemContent>
                <ListTitle>{retentionPolicy.type}</ListTitle>
                <MarkdownDescription markup={retentionPolicy.description}/>
            </ListItemContent>
        </ListItemLink>);
}
const styles = {
    calloutContainer: css({
        paddingBottom: space[16],
    }),
};
